import * as T from 'components/ui/typography'

import IconButton from 'components/shared/icon-button'

import React from 'react'
import { analytics } from 'utils/analytics'
import { useAppConfig } from 'hooks/features/use-features'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuLabel,
    DropdownMenuTrigger,
    DropdownMenuItem,
} from 'components/ui/dropdown-menu'
import { HelpCircleIcon, LifeBuoy, Mail, MessageCircle } from 'lucide-react'

const SupportMenu = React.memo(({}) => {
    const { appConfig } = useAppConfig()
    const trackSupport = (type: string) => {
        analytics.track('help_click', { type: type })
    }
    return (
        <DropdownMenu>
            <DropdownMenuTrigger className="flex items-center">
                <IconButton className="w-full" tooltip="Supporto">
                    <HelpCircleIcon />
                </IconButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent className=" p-3 mr-3">
                <DropdownMenuLabel>Supporto</DropdownMenuLabel>

                <div className="p-2 flex flex-col gap-4">
                    <DropdownMenuItem onClick={() => trackSupport('whatsapp')}>
                        <a
                            href={
                                appConfig.name === 'ArtQuiz'
                                    ? 'https://api.whatsapp.com/send?phone=393493596332'
                                    : 'https://api.whatsapp.com/send?phone=393792523936'
                            }>
                            <T.Small className="flex items-center gap-2">
                                <>
                                    <MessageCircle className="text-primary" /> Scrivici su Whatsapp!{' '}
                                </>
                            </T.Small>
                        </a>
                    </DropdownMenuItem>

                    <DropdownMenuItem onClick={() => trackSupport('mail')}>
                        <a
                            href={
                                appConfig.name === 'ArtQuiz'
                                    ? 'mailto:info@accademiaartquiz.it'
                                    : 'mailto:supporto@testyprep.it'
                            }>
                            <T.Small className="flex items-center gap-2">
                                <>
                                    <Mail className="text-primary" /> Scrivici una Mail!
                                </>
                            </T.Small>
                        </a>
                    </DropdownMenuItem>

                    <DropdownMenuItem onClick={() => trackSupport('website')}>
                        <a
                            href={
                                appConfig.name === 'ArtQuiz'
                                    ? 'https://exuberant-maraca-238.notion.site/Supporto-de3bc38f74134043b7ed3592bd9c5c90?pvs=4'
                                    : 'https://systematic-raven.super.site/'
                            }>
                            <T.Small className="flex items-center gap-2">
                                <>
                                    <LifeBuoy className="text-primary" /> Pagina di supporto
                                </>
                            </T.Small>
                        </a>
                    </DropdownMenuItem>
                </div>
            </DropdownMenuContent>
        </DropdownMenu>
    )
})

export default SupportMenu
